import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import ImageCardDnD from "./image-card";
import ImageCardCMS from "./image-card";
import Preview from "../../../sales-medical-records/components/Image/edit-preview-image/preview";
import { Button } from "react-bootstrap";
import {
  MAX_IMAGE_UPLOAD_LIMIT,
  resizeImage,
} from "../../../../constants/constants";
import { formatMessage } from "../../../../translations/format-message";
import { ImageTypeEnum } from "../../../../constants/enums/image-type-enum";
import { useStore } from "../../../../contexts/store-provider";
import { IMedicalRecordImagesList } from "../../../../models/response/ISMRResponse";
import { FormattedMessage } from "react-intl";

interface IProps {
  storeId: number;
}

const StoreCmsImages = (props: any) => {
  const { smrStore } = useStore();
  const {
    AddCMSSStoreImagesService,
    allCMSStoreImages,
    DeleteCMSStoreImageService,
    UpdateCMSStoreImagesOrderIdService,
    setImageUploadLoader
  } = smrStore;
  const [images, setImages] = useState<any[]>(allCMSStoreImages);
  const [selectedImage, setSelectedImage] = useState(-3);
  const [showPreview, setShowPreview] = useState(false);
  const fileInputRef = useRef<any>(null);

  useEffect(() => {
    if (allCMSStoreImages.length > 0) {
      setImages(allCMSStoreImages);
    }
    else{
      setImages([]);
    }
  }, [allCMSStoreImages]);

  const onModalClosed = () => {
    setShowPreview(false);
    setSelectedImage(-3);
  };

  const triggerFileSelect = () => {
    if (images.length >= MAX_IMAGE_UPLOAD_LIMIT) {
      toast.error(formatMessage("maximum_10_images_allowed"));
      return;
    }
    fileInputRef.current.click();
  };

  const handleDeleteImage = (indexToDelete: number) => {
    DeleteCMSStoreImageService(
      images[indexToDelete].Id,
      images[indexToDelete].MedicalRecordId,
      images[indexToDelete].OrderId
    );
  };

  const handleImageSelect = async (event: any) => {
    const files = Array.from(event.target.files ?? []);
    if (files.length + images.length > MAX_IMAGE_UPLOAD_LIMIT) {
      toast.error(formatMessage("upload_up_to_10_images_only"));
      return;
    }
    const validImageFiles = files.filter((file: any) =>
      file.type.startsWith("image/")
    );

    try {
      setImageUploadLoader();
      const files: File[] = Array.from(event.target.files ?? []);
      const validImageFiles = files.filter((file) =>
        file.type.startsWith("image/")
      );

      const medicalImagesDetails: any = [];

      for (let i = 0; i < validImageFiles.length; i++) {
        const file = validImageFiles[i];
        const base64Image = await resizeImage(file, 1600, 1600, 0.5);
        const thumbnailBase64 = await resizeImage(file, 200, 200, 0.1);

        medicalImagesDetails.push({
          MedicalRecordId: props.storeId,
          ImageType: ImageTypeEnum.StoreCMS,
          ImageSource: file.name,
          ImageBase64: base64Image,
          OrderId: images.length + i,
          ThumbnailImage: thumbnailBase64,
        });
      }

      if (medicalImagesDetails?.length > 0){        
        AddCMSSStoreImagesService({
          MedicalRecordId: props.storeId,
          medicalImagesDetails: medicalImagesDetails,
        });
      }
      //   setImages((prev: any) => [...prev, ...medicalImagesDetails]);
    } catch (error) {
      toast.error(formatMessage("error_processing_images"));
    }
    event.target.value = ""; // clearing the value after all the action
  };

  const handleShowEditor = (index: number) => {
    setSelectedImage(index);
    getImageByIndex(index);
    // setShowEditor(true);
  };

  const moveCard = (from: number, to: number) => {
    let newOrder: any[] = [];
    const updated = [...images];
    const [moved] = updated.splice(from, 1);
    updated.splice(to, 0, moved);

    // Create the new order array (if you need to send order to backend)
    newOrder = updated.map((img, index) => ({
      Id: img.Id,
      OrderId: index,
    }));

    setImages(updated);
    // Optionally, send new order to the backend here
    UpdateCMSStoreImagesOrderIdService({ MedicalImages: newOrder });
    // UpdateMedicalRecordOrderIdService({ MedicalImages: newOrder }, smrId)
  };

  const getImageByIndex = (index: number) => {
    // Implement as needed if you want to fetch more details.
  };

  const handleShowPreview = (index: number) => {
    setSelectedImage(index);
    getImageByIndex(index);
    setShowPreview(true);
  };

  return (
    <>
      <Toaster />
      {showPreview && (
        <Preview
          image={images[selectedImage]?.ImageBase64 || ""}
          onModalClosed={onModalClosed}
        />
      )}

      <div className="container-row" key={"STORE_CMS_IMAGES"}>
        <div className="label-wrapper">
          <span className="label-text">
            <FormattedMessage id={"cms_images"} />
          </span>
        </div>

        <div className="image-scroll-container ">
          {images.length === 0 && (
            <ImageCardCMS
              type="template"
              id="template"
              index={-1}
              viewOnly={true}
              images={[]} // No template image by default
              moveCard={() => {}}
              handleDeleteImage={() => {}}
              handleShowPreview={() => {
                setSelectedImage(-1);
                handleShowPreview(-1);
              }}
              handleShowEditor={() => {}}
            />
          )}
          {images.map((img: any, index: number) => (
            <ImageCardDnD
              type={"Before"}
              key={img.Id}
              id={img?.Id?.toString()}
              index={index}
              viewOnly={false}
              moveCard={moveCard}
              images={images}
              handleDeleteImage={() => handleDeleteImage(index)}
              handleShowPreview={() => handleShowPreview(index)}
              handleShowEditor={() => handleShowEditor(index)}
              // ...any other props your DnD/ImageCard expects
            />
          ))}
          <ImageCardCMS
            type="template"
            id="template"
            index={-1}
            viewOnly={true}
            images={[]} // No template image by default
            moveCard={() => {}}
            isAddImage={true}
            addImage={triggerFileSelect}
          />
        </div>

        {/* File input and upload button */}
        <input
          type="file"
          accept="image/*"
          multiple
          className="hidden"
          hidden={true}
          ref={fileInputRef}
          disabled={images.length === MAX_IMAGE_UPLOAD_LIMIT}
          onChange={handleImageSelect}
        />
      </div>
    </>
  );
};

export default observer(StoreCmsImages);
